<template>
  <div class="app-main-content">
    <quotation-list :quotation-type="PriceConstant.QUOTATION_LCL" />
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import QuotationList from '@/views/cargo/v0/Price/Quotation/components/quotationList'
export default {
  name: 'QuotationLcl',
  components: { QuotationList },
  data() {
    return {
      PriceConstant
    }
  }
}
</script>

<style scoped>

</style>
